<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <br v-if="label">

        <div :class="'form-check ' + dimensionClass" v-for="item in items" :key="item.id">
            <input :id="internalName + '-' + item.id" class="form-check-input" type="checkbox" :name="name" :value="item.id" :checked="isChecked(item.id)"/>
            <label :for="internalName + '-' + item.id" class="form-check-label">
                {{ item.first_name }} {{ item.last_name }}
            </label>
        </div>
        <div v-if="items.length == 0">
            <label>{{ this.forElseMessage }}</label>
        </div>
        <div class="invalid-feedback d-block" v-if="error">
            {{ error }}
        </div>

    </div>
</template>

<script>
export default {
    name: "CheckboxInput",
    props: {
        name: { type: String, required: true },
        label: { type: String, default: '', required: false },
        items: { type: Array, default: [], required: false },
        checked: { type: Array, default: [], required: false },
        dimension: { type: String, default: 'horizontal', required: false },
        forElseMessage: { type: String, default: 'No items available', required: false },
        error: { type: String, default: '', required: false },
    },
    computed: {
        internalName() {
            return this.name.replace(/[\[\]]/g,"");
        },
        dimensionClass() {
            if(this.dimension == 'vertical') {

                return 'form-check-vertical';
            }

            return 'form-check-inline';
        }
    },
    methods: {
        isChecked(id) {

            return this.checked.includes(id);
        },
    }
}
</script>